<template>
	<header id="main-header" class="main-header">
		<div class="header-left">
			<a href="/" class="flex flex-row align-items-center">
				<div class="main-logo"></div>
				<div class="campany-name">
					<div class="text d-flex flex-row align-items-center justify-content-between w-100"><span>汲悟科技</span>
					</div>
				</div>
			</a>
		</div>

		<div class="header-right">
			<el-dropdown trigger="click" style="margin-right:10px;" @command="handleCommand" size="medium">
				<el-button type="primary" round>合作产品</el-button>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item command="1">吉物安途-海外仓货损险</el-dropdown-item>
					<el-dropdown-item command="2">跨境电商商业综合责任险</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
			<!-- <el-button type="primary" round @click="openRouter('/pages/product')">产 品</el-button> -->
			<el-button v-if="user" type="primary" round @click="pushPath('/dashboard')">控制台</el-button>
			<el-button v-else type="primary" round><span @click="pushPath('/login')">登陆</span>
			<!-- ｜<span@click="pushPath('/signup')">注册</span> -->
			</el-button>
		</div>
	</header>
</template>

<script>
	import Common from '@/common/mixins/common.js'
	import {
		mapGetters
	} from 'vuex'
	export default {
		mixins: [Common],
		data() {
			return {
			}
		},
		computed: {
			...mapGetters({
				user: 'system/user'
			})
		},
		methods: {
			handleCommand(command) {
				switch (command) {
					case "1":
						this.$router.push('/general-cross-border-shipping-and-overseas-warehouse-cargo-damage-insurance')
						// window.open(process.env.VUE_APP_QSEBAO, '_blank')
						break
					case "2":
						window.open('https://emcs.pa18.com/ust?key=120250314156387604773912802&appType=01', '_blank')
						break
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	// Varibles
	$mobile: 768px;

	// Scss
	.main-header {
		height: 80px;
		z-index: 100;
		position: absolute;
		top: 0;
		left: 0;
		background-color: unset;
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		padding: 20px;

		.header-left {
			a {
				display: flex;
				flex-direction: row;
				align-items: center;

				.campany-name {
					margin-left: 10px;
					display: flex;
					flex-direction: column;
					align-items: center;

					.text {
						font-size: 14px;
						color: #F8FDBD;
					}

					.line {
						height: 2px;
						width: 100%;
						background: linear-gradient(to right, var(--linear-gradient-left), var(--linear-gradient-right));
					}


					&>div {
						font-size: 16px;
					}
				}
			}
			a:hover {
				text-decoration: none;
			}
		}

		.header-right button {
			color: #004767;
			min-width: 60px;
			font-weight: 700;
			border: 4px solid transparent;
			background-color: var(--button-bg-color);
		}

	}

	@media screen and (max-width: $mobile) {
		.main-header {
			height: 60px;
			padding: 15px;

			.header-left {
				a {
					.main-logo {
						width: 30px;
						height: 30px;
					}

					.campany-name {
						.text {
							font-size: 12px;
						}

						&>div {
							font-size: 13px;
						}
					}
				}
			}

			.header-right button {
				// margin-left: 15px;
				min-width: 40px;
				border: 0px solid transparent;
				font-size: 12px;
				padding: 5px 10px;
				// transform: scale(0.7, 0.7);
			}
		}
	}
</style>